import { ADULT, KIDS, YOUNGER_KIDS, ALLOWED_PROFILE_TYPES } from 'helpers/ProfileConstants';
import { DEFAULT_PROFILE_PIC } from 'helpers/ProfileConstants';
import Domain from 'helpers/Domain';
import { UserProfile } from 'vue/FormConfig';

export default {
    namespaced: true,
    state: {
        // what a BS flag, disable a feature that's already implemented. keep the flag here for easy enabling https://atlassian.cbsi.com/jira/browse/CBSSITE-9351
        KILLME_IN_Q1: true,

        // indicate refresh on switching to the same profile, but has gone through edit/create profile
        refreshOnClose: false,

        // if user on a page that has video player, this track the ready state of the player
        videoPlayerReady: false,

        originUrl: null,
        mainOverlay: false,
        profileMenu: false,
        // profile for who is currently watching
        currentProfile: null,

        // profile for who is being edited
        selectedUserData: null,

        userData: [],
        userProfileToken: null,
        avatarUUID: null,
        ratingsData: [],

        // v1
        availableAvatars: [],

        // v2
        GroupAvatars_ADULT: [],
        GroupAvatars_YOUNGER_KIDS: [],
        GroupAvatars_KIDS: [],

        tempAvatarUUID: null,
        tempProfileName: null,
        tempProfileType: null,
        kidModeConfirmPassword: false,

        isEditMode: false,
        isKidsProfileButtonEnabled: false,
        kidsBadgeImagePath: '',
        kidsMode: false,
        kidsModeHasChanged: false,
        isAddKidsButtonClicked: false,

        // profile form state
        profileForm: {
            id: null, // profile Id, not user Id
            name: null,
            profilePic: null,
            profilePicPath: null,
            profileType: null,
            locale: null,
            profilePicGroupId: null,
        },
        savedPin: ['', '', '', ''],
        isTimeUp: false,
    },

    mutations: {
        setTimeUp(state, payload) {
            state.isTimeUp = payload;
        },
        setSavedPin(state, payload) {
            state.savedPin = payload;
        },
        resetPin(state) {
            state.savedPin = ['', '', '', ''];
        },
        setOriginUrl: function (state, val) {
            state.originUrl = val;
        },
        workUserMenu: function (state, val) {
            state.profileMenu = val;
        },
        showFullOverlay: function (state) {
            state.mainOverlay = true;

            // get marquee on show detail page
            let heroVideo = $('.marqueeVideoContainer video');
            let heroVolume = $('.hero-volume');

            // CBSSITE-11780 pause/mute video when profile overlay shows
            setTimeout(() => {
                if (typeof window.smartTagAPI !== 'undefined') {
                    window.smartTagAPI.pageAction({ action: 'PageAction.MUTE' });
                    window.smartTagAPI.pageAction({ action: 'PageAction.PAUSE' });
                }
                if (typeof window.newsHub !== 'undefined') {
                    window.newsHub.mutePlayer();
                }
                if (heroVideo.length > 0) {
                    heroVideo[0].muted = true;
                    heroVolume.addClass('muted');
                }
            }, 25);

            let evt = new CustomEvent('userProfilesOn', { detail: 'Stop Hero Slides' }); //This event is used to turn off the hero slides-- stop hero slides from cycling when User Profile app is running.
            window.dispatchEvent(evt);
        },
        hideFullOverlay: function (state) {
            state.mainOverlay = false;

            setTimeout(() => {
                if (typeof window.smartTagAPI !== 'undefined') {
                    window.smartTagAPI.pageAction({ action: 'PageAction.PLAY' });
                    window.smartTagAPI.pageAction({ action: 'PageAction.UNMUTE' });
                }
                if (typeof window.newsHub !== 'undefined') {
                    window.newsHub.unmutePlayer();
                }
            }, 25);

            let evt = new CustomEvent('userProfilesOff', { detail: 'Start Hero Slides' }); //This event is used to turn off the hero slides-- stop hero slides from cycling when User Profile app is running.
            window.dispatchEvent(evt);
        },
        storeProfile: function (state, prof) {
            state.userData = prof;
        },
        storeAvailableAvatars: function (state, prof) {
            state.availableAvatars = prof;
        },
        storeAvailableGroupAvatars: function (state, payload) {
            state['GroupAvatars_' + payload.userProfileType] = payload.data;
        },
        storeRatingsData: function (state, rData) {
            state.ratingsData = rData;
        },
        setSelectedUserData: function (state, user) {
            state.selectedUserData = user;
        },
        setCurrentProfile: (state, payload) => {
            state.currentProfile = payload;
        },
        setUserProfileToken: function (state, token) {
            state.userProfileToken = token;
        },
        setTempAvatar: function (state, avatar_uuid) {
            state.tempAvatarUUID = avatar_uuid;
        },
        setTempProfileName: function (state, profile_name) {
            state.tempProfileName = profile_name;
        },
        setTempProfileType: function (state, profile_type) {
            state.tempProfileType = profile_type;
        },
        setVideoPlayerStatus: function (state, status) {
            state.videoPlayerReady = status;
        },
        setFormData: function (state, formData) {
            state.profileForm.id = formData.id;
            state.profileForm.name = formData.name;
            state.profileForm.profilePic = formData.profilePic;
            state.profileForm.profilePicPath = formData.profilePicPath;
            state.profileForm.profileType = formData.profileType;
            state.profileForm.locale = formData.locale;
            state.profileForm.profilePicGroupId = formData.profilePicGroupId;
        },
        setFormDataId: function (state, userId) {
            state.profileForm.profileId = userId;
        },
        setFormDataName: function (state, name) {
            if (name !== undefined) {
                state.profileForm.name = name;
            }
        },
        setFormDataType: function (state, type) {
            state.profileForm.profileType = type;
        },
        setFormDataPic: function (state, profilePic) {
            state.profileForm.profilePic = profilePic;
        },
        setFormDataPicPath: function (state, profilePicPath) {
            state.profileForm.profilePicPath = profilePicPath;
        },
        setFormDataGroupId: function (state, profilePicGroupId) {
            state.profileForm.profilePicGroupId = profilePicGroupId;
        },
        setFormDataLocal: function (state, locale) {
            state.profileForm.locale = locale;
        },
        setKidsMode: function (state, bool) {
            state.kidsMode = bool;
        },
        setKidsModeHasChanged: function (state, bool) {
            state.kidsModeHasChanged = bool;
        },
        setKidsBadgeImagePath: function (state, imagePath) {
            state.kidsBadgeImagePath = imagePath;
        },
        setKidsProfileButtonEnabled: function (state, isEnabled) {
            state.isKidsProfileButtonEnabled = isEnabled;
        },
        setEditMode: function (state, bool) {
            state.isEditMode = bool;
        },
        cleanProfileForm: function (state) {
            let userProfile = new UserProfile();
            state.isAddKidsButtonClicked = false;
            state.kidsMode = false;
            state.kidsModeHasChanged = false;
            state.profileForm = userProfile;
        },
        setKidModeConfirmPassword(state, bool) {
            state.kidModeConfirmPassword = bool;
        },
        setIsAddKidsButtonClicked(state, bool) {
            state.isAddKidsButtonClicked = bool;
        },
    },

    actions: {
        cleanProfileForm({ commit }) {
            commit('cleanProfileForm');
        },

        syncProfilesAndParentalControls({ commit }, payload = { fetch: true }) {
            return new Promise((resolve, reject) => {
                this.$profile_service
                    .syncProfilesAndParentalControls(payload.fetch)
                    .then((res) => {
                        if (res.success) {
                            if (res?.data?.profiles) {
                                commit('storeProfile', res.data.profiles);
                            }
                            if (res?.data?.activeProfile) {
                                commit('setCurrentProfile', res.data.activeProfile);
                            }
                            if (res?.data?.parentalControlSettings) {
                                let parentalSettings = res.data.parentalControlSettings;
                                let payload = {
                                    on: parentalSettings.parentalControlOn,
                                    pin: ['', '', '', ''],
                                    rating: parentalSettings.userParentalControlLevel,
                                    lockLiveTV: parentalSettings.lockLiveTV,
                                    requirePinSwitchProfileEnabled:
                                        parentalSettings.requirePinSwitchProfileEnabled,
                                    hasPin: parentalSettings.hasPin,
                                };
                                let useRoot = {
                                    root: true,
                                };
                                commit('parentalControls/setSaved', payload, useRoot);
                            }
                            resolve(res);
                        }

                        reject(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        getAvailableAvatars({ state, commit }) {
            return new Promise((resolve, reject) => {
                if (state.availableAvatars && state.availableAvatars.length > 0) {
                    resolve();
                    return;
                }

                this.$profile_service
                    .getAvailableAvatars()
                    .then((res) => {
                        commit('storeAvailableAvatars', res.data.avatars);
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        getAvailableGroupAvatars({ state, commit }, payload) {
            // payload.profileType is primarily optional

            return new Promise((resolve, reject) => {
                let userProfileType = payload?.profileType ?? state.profileForm.profileType;

                let list = state['GroupAvatars_' + userProfileType];

                if (list.length) {
                    resolve();
                } else {
                    let payload = {
                        userProfileType: userProfileType,
                    };
                    this.$profile_service
                        .getAvailableGroupAvatars(payload)
                        .then((res) => {
                            commit('storeAvailableGroupAvatars', {
                                data: res.data.result,
                                userProfileType: userProfileType,
                            });
                            resolve();
                        })
                        .catch((err) => {
                            reject(err);
                        });
                }
            });
        },

        getRatingsData({ state, commit }) {
            return new Promise((resolve, reject) => {
                if (state.ratingsData.length > 0) {
                    resolve();
                    return;
                }

                this.$profile_service
                    .getRatingsData()
                    .then((res) => {
                        commit('storeRatingsData', res.data.profileLevels);
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        deleteProfile({ state, commit }, payload) {
            payload.tk_trp = state.userProfileToken;

            return new Promise((resolve, reject) => {
                this.$profile_service
                    .deleteProfile(payload)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        disableKidsButton({ state, commit }) {
            return new Promise((resolve, reject) => {
                this.$profile_service
                    .disableKidsButton()
                    .then((res) => {
                        commit('setKidsProfileButtonEnabled', false);
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        whosWatching({ state, commit }, payload) {
            payload.tk_trp = state.userProfileToken;

            return new Promise((resolve, reject) => {
                this.$profile_service
                    .whosWatching(payload)
                    .then((res) => {
                        resolve(res);
                        commit('setCurrentProfile', res.result);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        createProfile({ state, commit }, payload) {
            payload.tk_trp = state.userProfileToken;

            return new Promise((resolve, reject) => {
                this.$profile_service
                    .createProfile(payload)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        updateProfile({ state, commit }, payload) {
            payload.tk_trp = state.userProfileToken;

            return new Promise((resolve, reject) => {
                this.$profile_service
                    .updateProfile(payload)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        createPin({ state, commit }, payload) {
            payload.tk_trp = state.userProfileToken;
            return new Promise((resolve, reject) => {
                this.$profile_service
                    .createPin(payload)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        verifyPinControl({ state, commit }, payload) {
            payload.tk_trp = state.userProfileToken;

            return new Promise((resolve, reject) => {
                this.$profile_service
                    .verifyPinControl(payload)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        relogin({ state, commit }, payload) {
            payload.tk_trp = state.userProfileToken;

            return new Promise((resolve, reject) => {
                this.$profile_service
                    .parentalRelogin(payload)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },

    getters: {
        getKidsProfileButtonEnabled: (state) => {
            return state.isKidsProfileButtonEnabled;
        },
        userData: (state) => {
            return state.userData;
        },
        checkExistingKid: (state) => {
            return (
                state.selectedUserData !== null &&
                state.selectedUserData.profileType !== ADULT &&
                state.profileForm?.profileType !== ADULT
            );
        },
        requireCreatePin: (state, getters, rootState, rootGetters) => {
            const requirePinToSwitchProfile = rootGetters['featureFlags/requirePinToSwitchProfile'];

            if (Domain.isInternational()) {
                const hasPin = rootGetters['parentalControls/hasPin'];

                return requirePinToSwitchProfile && state.kidsMode && !hasPin;
            }

            // Can we switch to kidsMode here too? Would prefer to be consistent
            return (
                requirePinToSwitchProfile &&
                !rootGetters['parentalControls/areOn'] &&
                state.profileForm.profileType !== ADULT
            );
        },
        enableCreatePin: (state, getters, rootState, rootGetters) => {
            return state.kidsMode && !rootState.parentalControls.saved.on;
        },
        avatarPathById: (state, getters, rootState, rootGetters) => (uuid) => {
            if (rootGetters['featureFlags/getFlagAvatar']) {
                return getters.handleAvatarsV2(uuid);
            } else {
                return getters.handleAvatarsV1(uuid);
            }
        },
        handleAvatarsV1: (state) => (uuid) => {
            let avatarData = state.availableAvatars.find((avatar) => avatar.uuid === uuid);
            return avatarData ? avatarData.filepath_avatar : null;
        },
        handleAvatarsV2: (state, getters) => (uuid) => {
            let avatarData;
            const groupsArrays = getters.availableGroupAvatars();
            for (const key in groupsArrays) {
                let group = groupsArrays[key]?.['result']?.['data'];
                if (Array.isArray(group)) {
                    for (var item in group) {
                        if (group[item].hasOwnProperty('uuid')) {
                            if (group[item]['uuid'] === uuid) {
                                avatarData = group[item];
                                break;
                            }
                        }
                    }
                }
            }
            return avatarData?.thumb ?? null;
        },
        getAvatarGroupId: (state, getters) => (uuid) => {
            let avatarData;
            const groupsArrays = getters.availableGroupAvatars();
            for (const key in groupsArrays) {
                let group = groupsArrays[key]?.['result']?.['data'];
                if (Array.isArray(group)) {
                    for (var item in group) {
                        if (group[item].hasOwnProperty('uuid')) {
                            if (group[item]['uuid'] === uuid) {
                                avatarData = group[item];
                                break;
                            }
                        }
                    }
                }
            }
            return avatarData?.groupId ?? null;
        },
        availableGroupAvatars:
            (state) =>
            (optionalProfileType = null) => {
                let userProfileType = optionalProfileType ?? state.profileForm.profileType;
                return ALLOWED_PROFILE_TYPES.includes(userProfileType)
                    ? state['GroupAvatars_' + userProfileType]
                    : [];
            },
        getAvailableGroupAvatarsForCarousel: (state, getters) => {
            if (state.kidsMode && state.profileForm.profileType === ADULT) {
                let kids = getters.availableGroupAvatars(KIDS);
                let youngerKids = getters.availableGroupAvatars(YOUNGER_KIDS);
                youngerKids.forEach((youngKidCarousel) => {
                    const isDuplicate = kids.filter((kidCarousel) => {
                        return kidCarousel.result.id === youngKidCarousel.result.id;
                    });
                    if (isDuplicate.length === 0) {
                        kids = [...kids, youngKidCarousel];
                    }
                });
                return kids;
            } else {
                return getters.availableGroupAvatars();
            }
        },
        haveAnyGroupAvatars(state) {
            return state.GroupAvatars_ADULT.length > 0;
        },
        defaultAvatarPath: (state, getters, rootState, rootGetters) => {
            if (rootGetters['featureFlags/getFlagAvatar']) {
                return getters.getDefaultAvatarPicPathV2;
            } else {
                return getters.getDefaultAvatarPicPathV1;
            }
        },

        getDefaultAvatarPicPathV1: (state) => {
            if (!state.availableAvatars || state.availableAvatars.length === 0) {
                return '';
            }

            let defaultAvatar = state.availableAvatars.find((el) => el.uuid === 'default');

            return defaultAvatar.profilePicPath;
        },
        getDefaultAvatarPicPathV2: (state, getters) => {
            let got = getters.handleAvatarsV2(DEFAULT_PROFILE_PIC);
            return got;
        },

        getProfileForm: (state) => {
            return state.profileForm;
        },
        getKidsBadgeImagePath: (state) => {
            return state.kidsBadgeImagePath;
        },
        isEditMode: (state) => {
            return state.isEditMode;
        },
        kidModeConfirmPassword: (state) => {
            return state.kidModeConfirmPassword;
        },
        validatePIN: (state) => {
            const pinArray = state.savedPin;
            for (let i = 0; i < pinArray.length; i++) {
                if (pinArray[i] === null || pinArray[i] === '') return false;
            }

            return true;
        },
        currAvatarGroupId: (state) => {
            return state.profileForm.profilePicGroupId;
        },
        isCurrentProfileChild: (state) => {
            return state.currentProfile?.profileType !== ADULT;
        },
        currentProfile: (state) => {
            return state.currentProfile;
        },
        isTimeUp: (state) => {
            return state.isTimeUp;
        },
        getIsAddKidsButtonClicked: (state) => {
            return state.isAddKidsButtonClicked;
        },
    },
};
